// Hand-written companion to the codegen output in `./gateways.ts`.
//
// `rtk-openapi.recalc.config.cjs` only lists `gateways.ts` (and its sibling
// endpoint files) as `outputFiles`, so re-running the recalc OpenAPI codegen
// never touches this file - customizations here survive regeneration.
//
// `gatewaysPutImageAsyncByidfile`'s generated `query()` passes the `body` arg
// (a plain `{ file: Blob }` object) straight through as the fetch body.
// `fetchBaseQuery` JSON-stringifies non-FormData bodies, which serializes a
// `Blob` to `{}` - an empty JSON payload - causing the API to reject the
// request with a 400 "Payload was empty" error. This override rebuilds the
// body as multipart `FormData`, mirroring what the old hand-written
// `src/api/recalc/endpoints/gatewayApiSlice.jsx` `uploadGatewayImage`
// mutation used to do.
import { recalcOpenApi } from './gateways';

export * from './gateways';

const enhancedRecalcGatewaysApi = recalcOpenApi.enhanceEndpoints({
  endpoints: {
    gatewaysPutImageAsyncByidfile: {
      query: (queryArg) => {
        const form = new FormData();
        form.append('file', queryArg.body.file);
        return {
          url: `/Gateway/${queryArg.id}/Image`,
          method: 'PUT',
          body: form,
        };
      },
    },
  },
});

export const { useGatewaysPutImageAsyncByidfileMutation } =
  enhancedRecalcGatewaysApi;
